<template>
  <div class="disputed-orders__pagination glass-pagination">
    <button 
      @click="emit('prev')" 
      :disabled="currentPage === 1"
      class="page-btn glass-btn-small"
    >Previous</button>
    <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
    <button 
      @click="emit('next')" 
      :disabled="currentPage === totalPages"
      class="page-btn glass-btn-small"
    >Next</button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: { type: Number, required: true },
    totalPages: { type: Number, required: true }
  },
  emits: ['prev', 'next'],
  setup(_, { emit }) {
    return { emit }
  }
}
</script>

<style scoped>
.disputed-orders__pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 0 0 20px 20px;
}

.page-btn {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  background: rgba(54, 64, 80, 0.85);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.page-btn:hover:not(:disabled) {
  background: rgba(54, 64, 80, 1);
  transform: translateY(-1px);
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-info {
  font-size: 13px;
  color: #64748b;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/Pagination.vue